import React from 'react';
import TechnicalFilm, { Film } from './TechnicalFilm';

const STUDIES: Record<string, Film> = {
    'how-rag-retrieval-actually-works': {
        directory: 'retrieval-flow',
        name: 'Retrieval selects context',
        title: <>Retrieval <em>selects context.</em></>,
        description: 'Encode a question, rank document chunks, and send selected context to the model. The answer comes afterward.',
        seconds: 8.5,
        articleSlug: 'how-rag-retrieval-actually-works',
        posterAlt: 'A query vector leads to ranked document chunks and a selected context stack.',
        disclosure: 'Concept diagram. Similarity bars are illustrative; no live inference.',
        transcript: [
            { time: '0:00 to 0:02', text: 'Encode the question as a query vector.' },
            { time: '0:02 to 0:05', text: 'Rank document chunks by similarity.' },
            { time: '0:05 to 0:06.8', text: 'Select the top two chunks as context.' },
            { time: '0:06.8 to 0:08.5', text: 'The model generates an answer afterward.' },
        ],
    },
    'llm-finetuning-lora': {
        directory: 'lora-update',
        name: 'Train the update. Freeze the base',
        title: <>Train the update. <em>Freeze the base.</em></>,
        description: 'Keep base weights fixed. Train two smaller matrices whose product updates the same weight shape.',
        seconds: 8.5,
        articleSlug: 'llm-finetuning-lora',
        posterAlt: 'Frozen base matrix W beside low-rank factors B and A, their product BA, and the sum W prime equals W plus BA.',
        disclosure: 'Concept diagram. LoRA scaling is omitted; no live training.',
        transcript: [
            { time: '0:00 to 0:01.6', text: 'Keep the base weight matrix W frozen.' },
            { time: '0:01.6 to 0:03.5', text: 'Train low-rank factors B and A.' },
            { time: '0:03.5 to 0:06', text: 'Their product BA has the same shape as W.' },
            { time: '0:06 to 0:08.5', text: 'W prime equals W plus BA; scaling is omitted.' },
        ],
    },
};

export default function MotionStudy({ articleSlug }: { articleSlug: string }) {
    const film = STUDIES[articleSlug];
    return film ? <TechnicalFilm key={articleSlug} film={film} inline /> : null;
}
